import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';
import { Country, State, City, IState, ICountry, ICity } from 'country-state-city';
import { getStatesOfCountry, getStateByCode } from 'country-state-city/lib/state';
import { ZipCodeService } from 'src/app/_services/zip-code.service';

@Component({
  selector: 'app-vendor-profile',
  templateUrl: './vendor-profile.component.html',
  styleUrls: ['./vendor-profile.component.css']
})
export class VendorProfileComponent implements OnInit {

  constructor(
    private loginService: LoginService,
    private authService: AuthService,
    private zipCodeService: ZipCodeService,
    private alertService: AlertService
  ) {
    // const countryCode = 'US'; // Country code for the USA
    // this.State = getStatesOfCountry(countryCode);
  }

  State = [];
  City = [];

  utcStr = new Date().toUTCString();
  submitted: boolean = true;
  status: boolean = false;
  isLoading: boolean = false;
  // Country:[]
  token = this.authService.getToken()
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  ngOnInit(): void {
    // this.country()
    this.getData();
  }

  getData() {
    // this.isLoading = true;
    this.loginService.profile('', '').subscribe((response) => {
      console.log("login response", response);
      this.myProfileForm.disable();
      this.myProfileForm = new FormGroup(
        {
          CustomerId: new FormControl(this.authService.getRegistredUserDetails().customerId),
          UserId: new FormControl(response['userId']),
          FirstName: new FormControl(response['firstName'], [Validators.required]),
          Email: new FormControl(response['email'], [
            Validators.required,
            Validators.email,
            Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
          ]),
          LastName: new FormControl(response['lastName'], [Validators.required]),
          organization: new FormControl(response['organization'], [Validators.required]),
          PhoneNumber: new FormControl(response['phoneNumber'], [
            Validators.required,
            Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
          ]
          ),
          State: new FormControl(response['state'], [Validators.required]),
          Address: new FormControl(response['address'], [Validators.required]),
          Country: new FormControl('US'),
          ZipCode: new FormControl(response['zipCode'], [
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(5)
          ])
        })
      this.isLoading = false;
    }, (err) => {
      this.isLoading = false;
      console.log(err);
    })
  }

  myProfileForm: FormGroup = new FormGroup(
    {
      CustomerId: new FormControl('', [Validators.required]),
      UserId: new FormControl('', [Validators.required]),
      FirstName: new FormControl('', [Validators.required]),
      Email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
      ]),
      LastName: new FormControl('', [Validators.required]),
      organization: new FormControl('', [Validators.required]),
      PhoneNumber: new FormControl('', [
        Validators.required,
        Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
      ]),
      State: new FormControl('', [Validators.required]),
      Address: new FormControl('', [Validators.required]),
      Country: new FormControl('US'),
      ZipCode: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(5)
      ])
    }
  )

  onSubmit() {
    if (!this.status) {
      this.myProfileForm.enable();
      this.status = true;
    }
    else {
      this.submitted = true;
      this.isLoading = true;

      if (this.myProfileForm.valid) {
        this.loginService.updateProfile(this.myProfileForm.value, this.token).
          subscribe((response) => {
            var logo = this.authService.getRegistredUserDetails().logoFile
            response['data'].logoFile = logo;
            this.authService.setRegistredUserDetails(response['data']);
            //this.authService.setProfileDetails(response);
            console.log(response);
            this.alertService.success('Success!! Profile Updated SuccessFully.', this.options);
            this.myProfileForm.disable();
            this.status = false;
            setTimeout(() => {
              this.isLoading = false;
            }, 200);
          },
            (err) => {
              console.log(err);
              this.alertService.error(err.error.errors.Messages[0], this.options);
              this.isLoading = false;
            })
      }
      else {
        console.log("Please enter valid details");
        // this.alertService.error('Error :( Please Enter Valid Details !', this.options);
        this.isLoading = false;
      }
    }
  }

  get forms() {
    return this.myProfileForm.controls;
  }

  reset() {
    this.myProfileForm.disable();
    this.status = false;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onPress(event) {
    const inputValue = event.target.value;
    const maxDigits = 11;
    if (event.target.value.length > 11) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.myProfileForm.value.PhoneNumber = event.target.value
    }
  }

  onZipCodeChange() {
    console.log('change');
    if (this.myProfileForm.value.ZipCode == null || this.myProfileForm.value.ZipCode.length == 0)
      return;
    this.zipCodeService.getDetailByZip(this.myProfileForm.value.ZipCode).subscribe((data: any) => {
      console.log(data);
      if (data == null) {
        return;
      }
      this.myProfileForm.patchValue({
        State: data.places[0].state
      });
    });
  }

}
